import styled from 'styled-components';

export const TextWrapper = styled.div`
    box-sizing: border-box;
    padding: 0px 16px;
    text-align: center;
`;

export const ButtonWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: stretch;
    gap: 16px;
    margin-top: 16px;
`;
